// import { useSelector } from "react-redux";
import currencyFormatter from "currency-formatter";
// import { settingsSelector } from "appredux/selectors";

const useFormatting = () => {
  // const setting = useSelector(settingsSelector);

  // sementara HardCode karena blm ada setting dari backend
  const setting = {
    app_currency_symbol: " Rp",
    show_app_currency_symbol: true,
    app_decimals: 0,
    app_currency_format: "2.,",
  };
  //formating currency by inits setting app_currency_format
  const currency = (
    val,
    {
      addonAfter = "",
      unformat = false,
      symbolNon = false,
      ifNull = false,
      precision,
      symbolDefault,
    } = {}
  ) => {
    let symbol = setting?.app_currency_symbol
      ? `${setting?.app_currency_symbol} `
      : "Rp ";

    if (!setting?.show_app_currency_symbol) {
      symbol = "";
    }

    if (symbolNon) {
      symbol = "";
    }

    if (symbolDefault) {
      symbol = symbolDefault;
    }

    if (precision === undefined) {
      if (setting?.app_decimals !== null) {
        precision = setting?.app_decimals;
      } else {
        precision = 0;
      }
    }

    let format = { symbol, decimal: ".", precision: 0 };
    if (setting?.app_currency_format === "0.,") {
      format = { symbol, thousand: ".", precision: 0 };
    } else if (setting?.app_currency_format === "2-.") {
      format = { symbol, thousand: "", decimal: ".", precision };
    } else if (setting?.app_currency_format === "2-,") {
      format = { symbol, thousand: "", decimal: ",", precision };
    } else if (setting?.app_currency_format === "2.,") {
      format = { symbol, thousand: ".", decimal: ",", precision };
    } else if (setting?.app_currency_format === "2,.") {
      format = { symbol, thousand: ",", decimal: ".", precision };
    } else if (setting?.app_currency_format === "2 .") {
      format = { symbol, thousand: " ", decimal: ".", precision };
    } else if (setting?.app_currency_format === "2 ,") {
      format = { symbol, thousand: " ", decimal: ",", precision };
    }
    let result = 0;
    if (unformat) {
      val = `${val || ""}`.split(format.thousand || "").join("");
      result = currencyFormatter.unformat(val || 0, format);
      result = `${result}${addonAfter}`;
    } else {
      result = currencyFormatter.format(val || 0, format);
      result = `${result}${addonAfter}`;
    }

    if (ifNull && result === "0") {
      return "-";
    }
    if (unformat === "format") {
      return format;
    }
    return result;
  };

  return {
    currency,
  };
};

export default useFormatting;
